import dayjs from "dayjs"
import { localisedValue } from "utils"

export const getAddTaskInitialValues = (lead, isEditing) => {
  const isValidUnixTimestamp = timestamp => Number.isInteger(timestamp) && timestamp > 0

  if (isEditing) {
    const statusDetails = lead?.inquiryStatusDetails || {}
    const tasks = lead?.tasks?.[0] || {}
    const calendarEvent = tasks?.CalendarEvent || {}
    const preFilledObject = {
      task:
        localisedValue({ object: statusDetails, key: "taskStatusGreatGrandParent" }) ||
        localisedValue({ object: statusDetails, key: "taskStatusParent" }),
      subTask:
        localisedValue({ object: statusDetails, key: "taskStatusGrandParent" }) ||
        localisedValue({ object: statusDetails, key: "taskStatusId" }),
      subofSubTask: localisedValue({ object: statusDetails, key: "taskStatusParent" }) || null,
      subLocation: localisedValue({ object: statusDetails, key: "taskStatusId" }),
      nextTask: localisedValue({ object: statusDetails, key: "nextStatusId" }),
    }

    return {
      task: preFilledObject.task?.toString(),
      completionDate: tasks?.deadline ? dayjs(tasks.deadline) : dayjs(),
      subTask: preFilledObject.subTask?.toString(),
      dateSlot: isValidUnixTimestamp(calendarEvent?.startTimeStamp) ? dayjs.unix(calendarEvent.startTimeStamp) : null,
      timeSlot: isValidUnixTimestamp(calendarEvent?.startTimeStamp)
        ? [dayjs.unix(calendarEvent.startTimeStamp), dayjs.unix(calendarEvent.endTimeStamp)]
        : null,
      subofSubTask: preFilledObject.subofSubTask?.toString(),
      subLocation: preFilledObject.subLocation?.toString(),
      attachment: tasks?.Attachments || [],
      comment: localisedValue({ object: tasks, key: "description" }) || null,
      nextTask: preFilledObject.nextTask?.toString(),
      deadLine: tasks?.Todo?.nextStatusDeadline ? dayjs(tasks.Todo.nextStatusDeadline) : dayjs(),
      project: localisedValue({ object: lead?.Project, key: "projectId" }),
      tsrClassification: lead?.inquiry?.InternalInquiryClassification?.id?.toString() || "",
      salesEvent: lead?.tasks?.find(item => item.hasOwnProperty("todoDetails"))?.salesEventId
    }
  }

  // For non-editing case
  return {
    deadLine: dayjs().add(3, "days"),
    attachment: [],
    project: localisedValue({ object: lead?.Project, key: "projectId" }),
    tsrClassification: lead?.inquiry?.InternalInquiryClassification?.id?.toString() || "",
  }
}
